const uiStore = {
  state: {
    isDark: false,
    loadingOverlay: false,
    prevRoute: null,
    statsProduct: undefined,
    reloadNotification: false,
    showAdvanced: false
  },
  getters: {
    isDark: function(state) {
      return state.isDark;
    },
    getLoadingOverlay(state) {
      return state.loadingOverlay;
    },
    getPrevRoute(state) {
      return state.prevRoute;
    },
    getStatsProduct(state) {
      return state.statsProduct;
    },
    getReloadNotification(state) {
      return state.reloadNotification;
    },
    getShowAdvanced(state) {
      return state.showAdvanced;
    }
  },
  mutations: {
    toggleDarkTheme: function(state) {
      state.isDark = !state.isDark;
    },
    setLoadingOverlay(state, value) {
      state.loadingOverlay = value;
    },
    setPrevRoute(state, value) {
      if (value.name !== null) state.prevRoute = value.name;
    },
    setStatsProduct(state, value) {
      state.statsProduct = value;
    },
    setReloadNotification(state, value) {
      state.reloadNotification = value;
    },
    setShowAdvanced(state, value) {
      state.showAdvanced = value;
    }
  },
  actions: {
    toggleDarkTheme: function({ commit }) {
      commit("toggleDarkTheme");
    },
    setLoadingOverlay({ commit }, payload) {
      commit("setLoadingOverlay", payload);
    },
    startLoadingOverlay({ commit }) {
      commit("setLoadingOverlay", true);
    },
    endLoadingOverlay({ commit }) {
      commit("setLoadingOverlay", false);
    },
    slo({ commit }) {
      commit("setLoadingOverlay", true);
    },
    elo({ commit }) {
      commit("setLoadingOverlay", false);
    },
    setPrevRoute({ commit }, payload) {
      commit("setPrevRoute", payload);
    }
  }
};

export default uiStore;
